import React from 'react';
import ErrorView from 'src/views/errors/ErrorView';

class React19ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('React 19 Error Boundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo || {},
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorView
          title="Application Error"
          text="Something went wrong. Please try refreshing the page or contact support if the problem persists."
        />
      );
    }

    return this.props.children;
  }
}

export default React19ErrorBoundary;
